import React from 'react';
import { List, Edit, Create, Datagrid, SimpleForm,
        TextField, DateField, NumberField,
        TextInput, EditButton, DeleteButton } from 'admin-on-rest';
import { CardActions } from 'material-ui/Card';
import { RefreshButton } from 'admin-on-rest';
import BulkBlacklistUseragentsButton from './BulkBlacklistUseragentsButton';

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const UseragentBlacklistActions = () => (
    <CardActions style={cardActionStyle}>
        <RefreshButton />
        <BulkBlacklistUseragentsButton />
    </CardActions>
);

export const UseragentBlacklistList = (props) => (
    <List title="User-agent blacklist" perPage={250} actions={<UseragentBlacklistActions />} {...props}>
        <Datagrid>
            <TextField source="useragent" label="Bevat tekst (in user agent)" sortable={false} />
            <TextField source="label" sortable={false} />
            <NumberField source="clicks_blocked" label="Kliks geblokkeerd" sortable={false} />
            <DateField source="created_at" showTime sortable={false} />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export const UseragentBlacklistEdit = (props) => (
    <Edit title="User agent bewerken" {...props}>
        <SimpleForm>
            <TextInput source="useragent" label="Tekst die de user agent moet bevatten" />
            <TextInput source="label" label="Label (optioneel)" />
        </SimpleForm>
    </Edit>
);

export const UseragentBlacklistCreate = (props) => (
    <Create title="User agent toevoegen aan blacklist" {...props}>
        <SimpleForm>
            <TextInput source="useragent" label="Tekst die de user agent moet bevatten" />
            <TextInput source="label" label="Label (optioneel)" />
        </SimpleForm>
    </Create>
);



// WEBPACK FOOTER //
// ./src/siteclicks/UseragentBlacklist.js